
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Card from 'vux/src/components/card/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Search from 'vux/src/components/search/index.vue'

export default {
filters: {
imgTextFilter(val) {
if (val.length > 2) {
return val.substring(0, 2)
}
return val
},
},
components: {
Grid,
XButton,
GridItem,
CellBox,
Flexbox,
Card,
FlexboxItem,
Toast,
Icon,
Search,
},
props: {
tree: {
type: Array,
},

request: {
type: Object,
},
color: {
type: String,
default: () => '#0984e3',
},
unit: {
type: String,
default: '人',
},

isCheckbox: {
type: Boolean,
default: false,
},
checkboxKey: {
type: String,
default: 'label',
},

isNum: {
type: Boolean,
default: false,
},

isBtn: {
type: Boolean,
default: false,
},

isFixed: {
type: Boolean,
default: false,
},

btnText: {
type: String,
default: '确定',
},
},
watch: {
tree: {
handler(newVal) {
if (newVal) {
this.data = newVal
} else {
this.httpRequest()
}
},
immediate: true,
deep: true,
},
},
data() {
return {
loadding: false,
newTree: this.tree,
navList: [
{
id: -1,
label: '全部',
},
],
data: this.tree,
currentRow: [],
isLast: false,
checkboxs: [],
}
},
methods: {
/** 行点击 */
rowHandler(row) {

if (this.navList.length === 1) {
this.currentRow = [row]
}

if (this.tree) {
if (!row.isLast) {
this.data = row.children
this.navList.push(row)
}
this.lastHandler()
} else {
if (!row.isLast) {
this.navList.push(row)
this.httpRequest(row.id)
}
}

this.isCheckboxFun(row)
},
goToModule(id) {
this.$router.push('/module/'+ id);
},
isCheckboxFun(row) {

if (this.isCheckbox && this.isLast) {
/** 判断当前对象是否选中 */

let rmIndex = []
for (let i = 0; i < this.checkboxs.length; i++) {
if (row[this.checkboxKey] === this.checkboxs[i][this.checkboxKey]) {
rmIndex.push(i)
}
}
if (rmIndex.length === 0) {
this.checkboxs.push(row)
} else {
rmIndex.forEach((val) => {
this.checkboxs.splice(val, 1)
})
}
this.$emit('change', this.checkboxs)
} else {
this.$emit('rowClick', row)
}
},
/** 导航点击 */
navHandler(item, index, flag) {

if (this.tree) {
if (item.label === '全部') {
this.data = this.tree
this.navList = [
{
id: -1,
label: '全部',
},
]
} else {

this.navList.splice(index + 1, this.navList.length)

this.backHandler(this.currentRow, item.label)
}
} else {
if (item.label === '全部') {
this.navList = [
{
id: -1,
label: '全部',
},
]
this.httpRequest()
} else {
if (!flag) {

this.navList.splice(index + 1, this.navList.length)
this.httpRequest(item.id)
}
}
}
if (!flag) {
this.checkboxs = []
this.$emit('navClick', item)
}
},
/** 返回上一级菜单并从树结构中获取最新组数据 */
backHandler(list, val) {
if (!list) {
return;
}
for (let i = 0; i < list.length; i++) {
if (list[i].label === val) {
this.data = list[i].children
this.lastHandler()
} else {
this.backHandler(list[i].children, val)
}
}
},
/** 判断当前数据是否是最后一组，如果children都是空数组则表示最后一级 */
lastHandler() {
for (let i = 0; i < this.data.length; i++) {
const child = this.data[i]
if (!child['children'] || child.children.length === 0) {
child.isLast = true
} else {
child.isLast = false
}
}
},
/** 判断是否选中 */
checked(val) {
return this.checkboxs.filter((che) => che.label === val).length > 0
},
/**
* 发送请求
*/
httpRequest(id) {
this.loadding = true
let xhr = new XMLHttpRequest()
let url = this.request.url
if (id) {
url += '?id=' + id
}
xhr.open('GET', url)
if (this.request['header']) {
Object.keys(this.request.header).forEach((head) => {
xhr.setRequestHeader(head, this.request.header[head])
})
}
xhr.onload = () => {
if (xhr.status === 200) {
const data = JSON.parse(xhr.responseText)
this.isLast = data.isLast
this.data = data.data
this.loadding = false
}
}
xhr.send()
},
},
}



// WEBPACK FOOTER //
// ./src/components/mobile-tree-vue/index.vue